<div class="ui-grid">
  <div class="p-grid">
    <div class="p-col-12">
      <app-reporting-client></app-reporting-client>
    </div>
    <!--<div class="p-col-12">
      <p-panel class="reporting" header="NOMBRE VALIDATION" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <app-reporting-attente-validation></app-reporting-attente-validation>
      </p-panel>
    </div>
    <div class="p-col-12">
      <p-panel class="reporting" [collapsed]="true" header="REPORTING MODERATION REJETES" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <app-reporting-moderation-rejeter></app-reporting-moderation-rejeter>
      </p-panel>
    </div>
    <div class="p-col-12">
      <p-panel class="reporting" [collapsed]="true" header="REPORTING GLOBAL" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <app-reporting-globale></app-reporting-globale>
      </p-panel>
    </div>
    <div class="p-col-12">
      <p-panel class="reporting" [collapsed]="true" header="REPORTING OPERATEUR" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <app-reporting-operateur></app-reporting-operateur>
      </p-panel>
    </div>
    <div class="p-col-12">
      <p-panel class="reporting" [collapsed]="true" header="REPORTING PAR TYPE DE CONTENU" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <app-statistique-volume-traiter></app-statistique-volume-traiter>
      </p-panel>
    </div>
  </div>-->
<!--  <div class="ui-grid-row">
    &lt;!&ndash; VOLUME TRAITER  &ndash;&gt;
&lt;!&ndash;    <div class="ui-grid-col-6">
      <p-panel header="VOLUME TRAITER">
        <app-volume-traiter></app-volume-traiter>
      </p-panel>
    </div>&ndash;&gt;-->
    <!-- STATISTIQUE CONTENU CREE -->
<!--    <div class="ui-grid-col-6">
      <p-panel class="p-col-6" header="STATISTIQUE CONTENU CREE OU COLLECTER">
        <app-nombre-contenu-traiter></app-nombre-contenu-traiter>
      </p-panel>
    </div>
  </div>-->
<!--  <div class="ui-grid-row">
    &lt;!&ndash; STATISTIQUE HEURE PROD &ndash;&gt;
    <div class="ui-grid-col-12">
      <p-panel header="STATISTIQUE HEURE PROD">
        <app-statistique-heure-prod></app-statistique-heure-prod>
      </p-panel>
    </div>
  </div>-->
   <!-- STATISTIQUE PERS PROD -->
<!--    <div class="ui-grid-col-12">
      <p-panel header="STATISTIQUE MOYENNE HEURE PROD">
        <app-statistique-prod-user></app-statistique-prod-user>
      </p-panel>
    </div>-->
  <!--
  <div class="ui-grid-row">
     STATISTIQUE VOLUME PAR TYPE DE CONTENU
    <div class="ui-grid-col-12">
      <p-panel header="STATISTIQUE VOLUME CONTENU PAR TYPE DE CONTENU">
        <app-statistique-volume-traiter></app-statistique-volume-traiter>
      </p-panel>
    </div>
  </div>
-->

<!--  <div class="ui-grid-row">
    &lt;!&ndash; STATISTIQUE MODERATION PAR ORDRE DE COMPLEXITE &ndash;&gt;
    <div class="ui-grid-col-12">
      <p-panel header="STATISTIQUE MODERATION PAR ORDRE DE COMPLEXITE">
        <app-statistique-complexiter></app-statistique-complexiter>
      </p-panel>
    </div>
  </div>-->

</div>


